<div
  class="dialog-actions secondary-action-row justify-content-end"
  [class.secondary-action-row--inline]="inline"
>
  <ng-content></ng-content>
</div>
